import React, { Component } from "react";
import PropTypes from "prop-types";
import DynamicGrid from "../DynamicGrid";
import { isNullOrEmpty } from "../Util";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";

const Settings = {
	ShowDateFilter: false,
	SortColumn: "invoice_number",
	UseTicketTypeFilter: false,
};

class InvoiceListing extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Invoices: [],
			ModalVisible: false,
			SelectedElevator: null,
			blocking: false,
		};

		this.openPdf = this.openPdf.bind(this);
		this.getData();

		var pathName = document.location.pathname.split("/");
		if (pathName.length === 5 && this.props.IsInvoices) {
			var invoice = pathName[4];
			if (!isNullOrEmpty(invoice) && !isNaN(invoice)) {
				this.openPdf({ invoice_number: invoice });
				console.log("invoice passed");
			}
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.BuildingID !== prevProps.BuildingID) {
			this.getData();
		}
	}

	async getData() {
		if (this.props.BuildingID) {
			var url = this.props.IsInvoices ? "Invoice/GetInvoices" : "Proposal/GetProposals";
			const data = await fetch(url, {
				method: "Post",
				cache: "no-cache",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ buildingsId: this.props.BuildingID }),
			});
			var res = await data.json();
			this.setState({ Invoices: res });
			// this.setState({ Elevators: res });
		}
	}

	async openPdf(row) {
		var dt = null;
		if (this.props.IsInvoices) {
			dt = row.invoice_number;
		} else {
			dt = {
				estimateNum: row.invoice_number,
				isPackingList: false,
				invoiceHeaderId: row.invoice_header_id,
			};
		}
		this.setState({ blocking: true });
		const data = await fetch((this.props.IsInvoices ? "Invoice" : "Proposal") + "/GetPdf", {
			method: "POST",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(dt),
		});

		if (data.ok) {
			var blob = await data.text();

			var tab = window.open();
			tab.location.href = document.location.origin + "/pdfs/" + blob;
		} else {
			alert("An error has occurred getting invoice, please contact Dynamic Elevator Control.");
		}
		this.setState({ blocking: false });
		this.getData();
	}

	async approveEstimate(row) {
		if (!row.is_viewed) {
			alert("Estimates must be viewed before they can be approved.");
			return;
		}

		await fetch("Proposal/ApproveClientProposal", {
			method: "POST",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ invoiceId: row.invoice_header_id }),
		});

		this.getData();
	}

	render() {
		var config = [];
		if (this.props.IsInvoices) {
			config = [
				{ header: "Invoice Number", columnName: "invoice_number", visible: true, typeCode: "N" },
				{ header: "Due Date", columnName: "due_date", visible: true, typeCode: "D" },
				{ header: "Total Amount", columnName: "amount", visible: true, typeCode: "$" },
				{ header: "Remaining Balance", columnName: "balance", visible: true, typeCode: "$" },
			];
		} else {
			config = [
				{ header: "Estimate Date", columnName: "invoice_date", visible: true, typeCode: "D" },
				{ header: "Estimate #", columnName: "invoice_number", visible: true, typeCode: "S" },
				{ header: "Total Amount", columnName: "amount", visible: true, typeCode: "$" },
				{ header: "Approved By", columnName: "signed_by", visible: true, typeCode: "S" },
				{
					header: "Approve Estimate",
					columnName: "approve_est",
					visible: true,
					Condition: function (row) {
						return !row.is_approved;
					},
					OnClick: (row) => this.approveEstimate(row),
					typeCode: "ACTION",
					style: { minWidth: "147px" },
				},
			];
		}

		return (
			<div style={{ flex: 1, backgroundColor: "#ebebeb", overflowY: "auto", padding: "4px" }}>
				<BlockUi tag="div" blocking={this.state.blocking}>
					<DynamicGrid Title={this.props.IsInvoices ? "Invoices" : "Estimates"} Configuration={config} DataSet={this.state.Invoices} Settings={Settings} OnRowClick={(row) => this.openPdf(row)} />
				</BlockUi>
			</div>
		);
	}
}

InvoiceListing.propTypes = {
	BuildingID: PropTypes.string,
};

export default InvoiceListing;
